import React from 'react';

export default () => (
  <svg width="40" height="40" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="1.5">
      <path d="M16 .84L16 31.16M.84 16L31.16 16" transform="translate(4 4)" />
    </g>
  </svg>
);
